module.exports = require('./toPairsIn');



//////////////////
// WEBPACK FOOTER
// ./~/lodash/entriesIn.js
// module id = 474
// module chunks = 0